// Helper functions for user data management

export const getUserData = () => {
    try {
        const userData = localStorage.getItem('user_data');
        if (userData && userData !== 'undefined' && userData !== 'null') {
            return JSON.parse(userData);
        }
        return null;
    } catch (error) {
        console.error('Error parsing user data:', error);
        return null;
    }
};

export const isSupervisor = () => {
    const userData = getUserData();
    return userData?.supervisor === 1;
};

export const hasPermission = (permission) => {
    // const userData = getUserData();
    // További jogosultság ellenőrzések itt implementálhatóak
    switch (permission) {
        case 'admin':
            return isSupervisor();
        default:
            return false;
    }
};